import getApiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const deleteProductType = (
    token: string,
    backend: string,
    id: string,
) => {
    return fetch(
        `${getApiUrl(backend)}producttypes/${id}`,
        {
            method: 'DELETE',
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
    );
};

export default deleteProductType